import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { urls } from '../../../../environments/environment';

@Injectable()
export class LinkShortenerService {

  constructor( private http: HttpClient) { }

  criarLinkEncurtado(url) {
    return this.http.post(`${urls.shortener}`, {
      originalLink: url,
      sourceApi: 'paguela'
    }, {
      responseType: 'text'
    });
  }

}
